const element = document.querySelector('.js-nav-list');

if (element) {
	init();
}

function init() {
	element.classList.add('is-initialised');
	const items = Array.from(element.querySelectorAll('.js-nav-list-item'));

	items.forEach(function toggleNavItem(element) {
		let isOpen = false;

		const toggle = element.querySelector('.js-nav-list-toggle');

		if (!toggle) {
			return;
		}

		toggle.addEventListener('click', () => {
			isOpen = !isOpen;
			element.classList.toggle('is-open', isOpen);
		});
	});
}
